<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row v-auth-acl="'gh-pres-dash-read'">
      <v-col cols="12" sm="12" lg="12">
        <v-card flat class="mb-7">
          <v-card-title class="justify-space-between">
            <h3>AVANCE PRESUPUESTAL GH - {{ añoActual.getFullYear() }}</h3>
            <div>
              <v-chip color="primary" dark @click="exportExcel(1, nameopexf)" :class="['ml-3']">
                <v-icon color="white">mdi-cloud-download</v-icon>
                <span :class="['ml-3']">
                  OPEXF
                </span>
              </v-chip>
              <v-chip color="primary" dark @click="exportExcel(2, nameopexa)" :class="['ml-3']">
                <v-icon color="white">mdi-cloud-download</v-icon>
                <span :class="['ml-3']">
                  OPEXA
                </span>
              </v-chip>
              <v-chip color="primary" dark @click="exportExcel(3, namecapexa)" :class="['ml-3']">
                <v-icon color="white">mdi-cloud-download</v-icon>
                <span :class="['ml-3']">
                  CAPEX
                </span>
              </v-chip>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
      <iframe id="container" style="width: 100%;height: 100vh;margin: 10px;" :src="url"></iframe>
    </v-row>
    <div v-if="showLoading" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
// import * as pbi from 'powerbi-client';

import PresupuestoService from '@/giplan/presupuesto/dashboard/services/PresupuestoService';
import { decryptAES } from '@/components4x/utils/utils4x';
import Swal from 'sweetalert2';

export default {
  name: 'Dashboard',

  data: () => ({
    presupuestoService: null,
    url: '',
    nameopexf: null,
    nameopexa: null,
    namecapexa: null,
    showLoading: false,
    page: {
      title: 'Presupuesto'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'Dashboard',
        disabled: true
      }
    ],
    añoActual: new Date()
  }),
  components: {
    // PorPeriodo: () => import('../components/PorPeriodo'),
    // PorArea: () => import('../components/PorArea'),
    // PresupuestosCards: () => import('../components/PresupuestosCards')
  },
  methods: {
    async alertDialog(type, title) {
      return await Swal.fire({
        icon: type,
        title: title,
        confirmButtonText: `OK`
      });
    },
    async exportExcel(type, name) {
      const emp = decryptAES(localStorage.getItem('emp'));
      const token = localStorage.getItem('token');
      console.log(token, type, name);
      if (name != null) {
        await this.presupuestoService.downloadResource(
          'descargar',
          {
            idempresa: emp,
            token: token,
            tipo: type
          },
          `${name}`
        );
      } else {
        await this.alertDialog('error', 'SIN ARCHIVO');
      }
    },
    async cargarData() {
      this.showLoading = true;
      const emp = decryptAES(localStorage.getItem('emp'));
      const res = await this.presupuestoService.get().execResource('archivos', {
        idempresa: emp
      });
      if (res.length > 0) {
        this.url = res[0].url;
        this.nameopexf = res[0].nombrefile1;
        this.nameopexa = res[0].nombrefile2;
        this.namecapexa = res[0].nombrefile3;
      }
      this.showLoading = false;
    }
  },
  async created() {
    this.presupuestoService = this.$httpService(new PresupuestoService(), this);
    await this.cargarData();
  },
  mounted() {
    // var permissions = pbi.models.Permissions.All;
    //
    // var config = {
    //   type: 'report',
    //   //tokenType: pbi.models.TokenType.Embed,
    //   //accessToken: 'H4sIAAAAAAAEACWWtQ7sCBZE_-WlXslMK03QZmbOzMxu02j_fXs0eSW3VFX3_P3HSp9hTos___0DQIfa7ln3aQzt9GkQlP0JN1bceBKKwI_lw5KTxiwpIT5MdwV3nMBtD8sgsosZHW29kg2q4rbC9DzNtLiwwqhfXEB8JGoBEDo_zjHRoUXflcEcShthKCB53ongwZMEB3xMD4vBXnJY4owTZQunECmIXeJvJH3MWp8bjQdOmGmAyq7RPQ3oUOrMp7B0zNxCEdyoDMZZyZjjrAWmoZnqWGxJvFyYQ9MyhVugvJea8C23zFonkDdJFYgeeD2UhyrMUlS02IK_iA7qlhrTds4fy9YOgYDnjnFf3-8bFwlKGRA9rmWwkUUpNzjqkg1XvXtpS6C8bumIvkZcfazcAjFwfF8NFXi6YQNogrCmXPnmsvgX7ncR4Oa2s0Jhij7p_CxPX7srwyFdsZvg8ZK3QR_a2XET22Fg3YqbwRBaD7avNEnxqqLKGm6Uat5aqf0M5fsX_67drCdgooX8F0Ic1ZGacy1J6MXC0dVwIEvwSEfTQKTgoovQ5JWIcOhYlrHgp-VXbxsTfDku3KxYO63mnqOs27usis65C3neVlyHGymXZjmDRUsc2Qc96VCb-DKLCBXDz56UxcZ8eUOT4jSgsju8GJHq_alm7TGvR9HxfaAUhWTLPlvGezl6Ndt5PnG5eU-7gaciReDCrs2mTzUfK4e8rsLyKKPYXFCN5iERp-oH1b1gF8DJjOWGPjBfut0uCuRR4bRPhiI1WPZqo7HzR-M8OBu9dWAsReRbuJcCB9q9jdrYXCOLdhSOFJUIJy0CuwF9x6ginLF5BJ99Z4XsvM4Jl5yEYE5nb2IdnN8y-1wFcFZsTCkflLAjixn2W8aWBljzrV48c0pTZgHRa8brqtAByHWKdp_yX5TKMqCSdY7YKCuxX3HIFnOkoFQeQX5Kmo73UPxQaHTD-7DRuahW5GFXyXdfeKbjzBbyuWU6yI-tOygFACF-r2-IrmwDQRV4jvetVWBGAJK0WqgnDq2qxg5QF89IF5sYOsaos6ybpYK7giOdFamOmDA2TDPSfYLudF7I3-0RvF95qDCWUmcadJIxu5Av7qVPZArLwms2x8jq6toBVB3-HFhbij20dMNQtxmYQFNm7MVnSxmnG8R6pO9l9Y4ePwVdimSPZw-OJ5IvK-Lb7twrnIGZmlWvHouenC7ntbzHuJUSGRzT6Yx5UDbzvT3hSB8FV65iTS4MutxnAUXMtF_j_LnU7zU7V8-cJBWtbnqpKPx8NMosaddmSvEg6kzO26WfMqVJhfN2cuDLZFVN8KbjXdJK8PFbWO5CeYDSEMcRaFvX2PENrcNewG2Q-oMIWrduZV71vaWJVHdYvoN9f7pRUhI_mzxA-yAZXjPsgg8VYVUqOMMOTH7IHQpUYyzQ2YuYLaZXpWV9wSdjMUdIWMg2nl4fPidWVJ7Ra3OF7ZiKBdFnY-8_RCp39fKKJSxG2nUjywKB44x9vzB652apObAFHkYTKiL5G6oMZ2qYI3mJUib1Sfub20mk-TpeNXYjg0E2tLGREpW0PryH4s61Z--FQSnNTSQMSDBurbIR7OsW5JvohxtpYmOzRTZ-bU66yi3rcnsGf4OlGoVRf6N2JOQphEVuauunb124Cw_0LyUNSK7fXh_sFmALNEceNZDbt-KVGK246Hs1JDDgQZqMI5y7cwn6owjvlLJPboW0w6oNK9ibnH8pcR2bnZEh4LPw1_fziGV5JEiGxjuF-56xhBDEeOYiUTswq1tIzTqjF-ZiS2WPrwzDw5CFXQRR8YEadnTexYAVzYkDT7epdLKR1OraWUkOz4KIXqF8ZLG_MvSHLPULxsyhjlJ-8OZLAibhatZeMD3O_6gWmFS57YoQFSOaKMtp6kQUmLBfzRegj-diMj8AQkk8OyDP4Y1DWtZ-_ec30fPcVNZXRvtvCYYDcwVN9tLJeGrfiuV_Q-kT-mWRw8VyWn5QWRHjqNpzyZNi-Xg9l9WlZhEW_Bl4I7kVSSpCcKkvjGeDRGjr4ALk6bn1asI0lPAhqog0OOTY1Tm2WACX6t0xIitPbgdoAGoRAwQMHQj9PS7KpgP7ALBI0fqzudwP9hr0d5GcAPXkbzeJhFVLHAkO91rkJ8bblJyHmgwjnEuFWSXaaJjew28LVFUL_A49ntHg_vznD7s9yzGr5fPDCfM5Kn56mBLl9WuBygF3kxZZNnR0qzVh5S2Ypnq35dhmxnkhVaTZj2y6d07cUIkLTcQkFm5ZX7fZUP_rQLBYs7CgqCbI4XcJ7nbPga5SvxdFJ9nwtL7QD-aRBjr8bHoq80EfbD6V4F86JJVxnPwidGBdc5DpEK8VJ8iZV4micvIUkINzXEnk17XkByTiqmQaR3177BlarPjA54foLkyURzLGhb3Mz7kT2vXOjboS2deon1QWzXmia_1-W2WHXSek7JRaeKObSjmWQYGtOVVr-TJqoPDuNho68zab3VjhTnwNdw436Y-9xvsPHwLG6M1qXWJ7_p2tib6uj23HG8wDlYV__fXXPzY_S1NucvBzmew-p_9mix48knIOqR8Eb_qvym3rKT2-W_mTDdccbs2MSyxCggAqFWGjLCnokiSq6ccv7R7sbhdLss4v30vtCR5el20KeO7AiucUtOe2cLYxCarloNntqLVGI4IVR5NY8GUOyVjIe8ktTwWPmVr7OgfFWzbB8DcWPmbCy1Jg8jsblsYkkoC52juqZv3ASzsHYYzBxzJjSG4TZP6DWgppNG6tWPmZbvp6f3rwi1hb5Sx2GJZ-AqHJHa1E9EMS7kHFStUkJHJi3QTz6Cnu9_5kAYYhhRw19xD6Y99EcBUhWQMcH226YYkJ_W-84rkO5Y33UhvnHclksCwRtkQ50j-yOGYpaOtFX5zsZeWmN1TOvcMfAvKo7c5ETvvYIR_1z-b__R9GklbbQgsAAA==',
    //   embedUrl:
    //     'https://app.powerbi.com/view?r=eyJrIjoiNGI5YmQ0YjgtNzg4NC00NjU2LWFmOWEtY2UxNjBkZmRiZmZlIiwidCI6IjkxOTNkYjY0LTU3NDgtNDNkZC05YTY4LTVhMjExY2M5NGJlOCIsImMiOjR9',
    //   //id: 'f6bfd646-b718-44dc-a378-b73e6b528204',
    //   permissions: permissions,
    //   settings: {
    //     filterPaneEnabled: true,
    //     navContentPaneEnabled: true
    //   }
    // };
    //
    // let powerbi = new pbi.service.Service(
    //   pbi.factories.hpmFactory,
    //   pbi.factories.wpmpFactory,
    //   pbi.factories.routerFactory
    // );
    // var reportContainer = document.getElementById('container');
    // var report = powerbi.embed(reportContainer, config);
    //
    // report.off('loaded');
    //
    // report.off('rendered');
    //
    // report.on('error', function() {
    //   this.report.off('error');
    // });
  }
};
</script>
